/**
 * Created by tomers on 10/1/2015.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");

    var KEYS = {
        APPLICATION_KEY: "applicationKey",
        NAME: "name",
        DATE_CREATED: "dateCreated",
        OPERATING_SYSTEM: "operatingSystem",
        DEV_APP: "devApp",
        DESCRIPTION: "description",
        CERTIFICATE: "certificate",
        CERTIFICATE_ID: "certificate.id",
        CERTIFICATE_FILE_NAME: "certificate.name",
        CERTIFICATE_REVISION: "certificate.revision",
        KEY: "key",
        KEY_ID: "key.id",
        KEY_FILE_NAME: "key.name",
        KEY_REVISION: "key.revision",
        KEY_FILE_DATA: "key.fileData",
        ANDROID_KEY_FOR_UPDATE: "serverKeyString",
        ENDPOINT_URL: "endpointURL",
        PROXY_AUTHORIZATION_HEADER: "serverKeyString"
    };

    var CONST = {
        DEFAULT_OPERATING_SYSTEM: 0,
        APP_NAME_MAX_LENGTH: 50
    };

    var OPERATING_SYSTEMS = {
        IOS: 0,
        ANDROID: 1,
        PROXY: 3
    };

    var IMPORT_FILE_TYPE = {
        CERTIFICATE: 1,
        KEY: 0
    };

    var NAME = "AppKeyModel";

    var AppKeyModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AppKeyModel = RevisionedModel.extend({
            OPERATING_SYSTEMS: OPERATING_SYSTEMS,
            KEYS: KEYS,
            MAX_NAME_LENGTH: CONST.APP_NAME_MAX_LENGTH,
            resource: ApiResources.Applications.AppKey,
            idAttribute: "applicationKey",
            name: NAME,
            defaults: {
                applicationKey: null,
                name:"",
                operatingSystem: CONST.DEFAULT_OPERATING_SYSTEM,
                devApp: true,
                description: "",
                certificate: {},
                key: {
                    fileData: ""
                }
            },

            validation: {
                name: [
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEManager.appEdit.app.errors.name.required"
                    },
                    {
                        maxLength: CONST.APP_NAME_MAX_LENGTH,
                        msg: {
                            key: "LEManager.appEdit.app.errors.name.length",
                            args: [CONST.APP_NAME_MAX_LENGTH]
                        }
                    }
                ],
                endpointURL: [
                    {
                        required: function() {
                            return this.isProxy();
                        },
                        minLength: 1,
                        msg: "LEManager.appEdit.app.errors.proxyEndpointURL.required",
                    },
                    {
                        pattern: "fullLowerCaseHttpsUrl",
                        msg: "LEManager.appEdit.app.errors.illegalChars.https.text"
                    },
                ],
                "key.fileData": {
                    required: function() {
                        return this.isAndroid();
                    },
                    minLength: 1,
                    msg: "LEManager.appEdit.app.errors.androidNotificationKey.required"
                }
            },

            /* private getter setter */
            _getValue: function (key) {
                return this.get(key);
            },
            _setValue: function (key, value) {
                this.set(key, value);
            },

            getDateCreated: function() {
                return this._getValue(KEYS.DATE_CREATED);
            },

            getAppKey: function () {
                return this._getValue(KEYS.APPLICATION_KEY);
            },
            setName: function (name) {
                this._setValue(KEYS.NAME, name);
            },

            getName: function () {
                return this._getValue(KEYS.NAME);
            },
            getOperatingSystem: function () {
                return this._getValue(KEYS.OPERATING_SYSTEM);
            },
            setOperatingSystem: function (operatingSystem) {
                this._setValue(KEYS.OPERATING_SYSTEM, operatingSystem);
                if (this.isIOS())  {
                    this.unset(KEYS.ANDROID_KEY_FOR_UPDATE, {silent: true});
                }
                else if (this.isAndroid()) {
                    this.set(KEYS.ANDROID_KEY_FOR_UPDATE, this.getAndroidNotificationKey(), {silent: true});
                } else if (this.isProxy()) {
                    this.set(KEYS.ENDPOINT_URL, this.getEndpointURL(), {silent: true});
                }
            },
            isAndroid: function() {
                return (this.getOperatingSystem() === OPERATING_SYSTEMS.ANDROID);
            },
            isIOS: function() {
                return (this.getOperatingSystem() === OPERATING_SYSTEMS.IOS);
            },
            isIos: function(){
                return this.getOperatingSystem() === OPERATING_SYSTEMS.IOS;
            },
            isProxy: function() {
                return this.getOperatingSystem() === OPERATING_SYSTEMS.PROXY;
            },

            getEndpointURL: function() {
                return this._getValue(KEYS.ENDPOINT_URL);
            },

            setEndpointURL: function(endpointURL) {
                this._setValue(KEYS.ENDPOINT_URL, endpointURL);
            },

            getProxyAuthorizationHeader: function() {
                return this._getValue(KEYS.PROXY_AUTHORIZATION_HEADER);
            },

            setProxyAuthorizationHeader: function(authorizationHeader) {
                this._setValue(KEYS.PROXY_AUTHORIZATION_HEADER, authorizationHeader);
            },

            getDevApp: function () {
                return this._getValue(KEYS.DEV_APP);
            },
            setDevApp: function (devApp) {
                this._setValue(KEYS.DEV_APP, devApp);
            },

            getAndroidNotificationKey: function() {
                return this.get(KEYS.KEY_FILE_DATA);
            },

            setAndroidNotificationKey: function(notificationKey) {
                this.setAndroidKeyForUpdate(notificationKey);
                this.set(KEYS.KEY_FILE_DATA, notificationKey);
            },

            setAndroidKeyForUpdate: function(notificationKey){
                this.set(KEYS.ANDROID_KEY_FOR_UPDATE, notificationKey);
            },

            getCertificate: function(){
                return this._getValue(KEYS.CERTIFICATE);
            },
            getCertificateId: function(){
                return this._getValue(KEYS.CERTIFICATE_ID);
            },
            getCertificateFileName: function(){
                return this._getValue(KEYS.CERTIFICATE_FILE_NAME);
            },
            getCertificateRevision: function() {
                return this._getValue(KEYS.CERTIFICATE_REVISION);
            },
            setCertificate: function(certificateObjFromServer) {
                this.set(KEYS.CERTIFICATE, certificateObjFromServer);
            },

            getKey: function(){
                return this._getValue(KEYS.KEY);
            },
            getKeyId: function(){
                return this._getValue(KEYS.KEY_ID);
            },
            getKeyFileName: function(){
                return this._getValue(KEYS.KEY_FILE_NAME);
            },
            getKeyRevision: function() {
                return this._getValue(KEYS.KEY_REVISION);
            },
            setKey: function(keyObjFromServer) {
                this.set(KEYS.KEY, keyObjFromServer);
            },

            isCertificateSet: function(){
                return this.isIos() && !_.isUndefined(this.getCertificateId());
            },
            isKeySet: function(){
                return this.isIos() && !_.isUndefined(this.getKeyId());
            },
            hasMissingFile: function(){
                return (this.isIOS && !this.isCertificateSet() || !this.isKeySet());
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    AppKeyModel.NAME = NAME;
    AppKeyModel.KEYS = KEYS;
    AppKeyModel.OPERATING_SYSTEMS = OPERATING_SYSTEMS;
    AppKeyModel.IMPORT_FILE_TYPE = IMPORT_FILE_TYPE;
    AppKeyModel.MAX_NAME_LENGTH = CONST.APP_NAME_MAX_LENGTH;

    return AppKeyModel;
});
